// extracted by mini-css-extract-plugin
export var backdropBlur = "_li-0";
export var contentCard = "_li-5";
export var frame = "_li-2";
export var image = "_li-4";
export var imagePane = "_li-3";
export var modal = "_li-1";